// extracted by mini-css-extract-plugin
module.exports = {"star":"_699645","disabled":"_796cb4","progressContainer":"_4228a1","root":"_8e42e0","number":"_7d33d4","reviewNumbers":"_3c3f30"};